import { render } from "./paypockets.vue?vue&type=template&id=66e94256"
import script from "./paypockets.vue?vue&type=script&lang=js"
export * from "./paypockets.vue?vue&type=script&lang=js"

import exportComponent from "/Users/agostinodegirolamo/Dropbox/Mac/Documents/Progetti/TTRE/Rapportino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__